import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  justify-content: space-between;
  align-items: center;
  /* width: 80%; */
  color: #000;
  /* margin: 0 auto 10px; */
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.space? 'space-between': 'center'};
`;

export const Text = styled.p`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;
